import {attr, controller, target} from '@github/catalyst'
import {currencyFormatter, getUnitData} from './utils'
import type {UnitData} from './utils'

@controller
export class PackagesCalculatorElement extends HTMLElement {
  @target declare bandwidthInput: HTMLInputElement
  get bandwidth() {
    return parseInt(this.bandwidthInput.value) || 0
  }

  @target declare storageInput: HTMLInputElement
  get storage() {
    return parseInt(this.storageInput.value) || 0
  }

  @target declare usesActionsInput: HTMLInputElement
  get usesActions() {
    return this.usesActionsInput.checked
  }

  @target declare subtotalElement: HTMLElement

  @attr costPerMonth = 0
  @attr active = false

  declare unit_data: UnitData

  connectedCallback() {
    this.unit_data = getUnitData()
  }

  displayCostPerMonth() {
    this.subtotalElement.textContent = currencyFormatter.format(this.costPerMonth / 100)
  }

  calculate() {
    const multiplier = this.usesActions ? this.unit_data.packages_action_toggle!.value : 1
    const storageCost = this.storage * this.unit_data.packages_storage!.value
    const bandwidthCost = this.bandwidth * this.unit_data.packages_bandwith!.value * multiplier

    this.costPerMonth = storageCost + bandwidthCost
  }

  resetButtonClicked(event: PointerEvent) {
    event.preventDefault()
    this.bandwidthInput.value = ''
    this.storageInput.value = ''
    this.usesActionsInput.checked = false
    this.costPerMonth = 0
  }

  getSummaryForCSV() {
    // headers: ['Service', 'Configuration Summary', 'Notes', 'Cost Per Month']

    return [
      [
        'Packages',
        `"Storage (GB): ${this.storage}, Bandwidth (GB): ${this.bandwidth}, Uses Actions?: ${this.usesActions}"`,
        '',
        `"${currencyFormatter.format(this.costPerMonth / 100)}"`,
      ],
    ]
  }

  static observedAttributes = ['data-cost-per-month', 'data-active']
  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null): void {
    if (oldValue === newValue) {
      return
    }

    if (name === 'data-cost-per-month' || name === 'data-active') {
      this.displayCostPerMonth()
      document.dispatchEvent(
        new CustomEvent('subtotalChanged', {
          detail: {sectionName: 'packagesTotal', amount: this.costPerMonth, active: this.active},
        }),
      )

      document.dispatchEvent(
        new CustomEvent('formDataUpdated', {
          detail: {sectionName: 'packages', resetEnabled: Boolean(this.costPerMonth)},
        }),
      )
    }
  }
}
